/**
 * Detects the user's platform based on navigator.userAgent.
 * Used to adjust emphasis of download vs email options.
 */
export function detectPlatform(): 'ios' | 'android' | 'desktop' {
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  if (/android/i.test(ua)) return 'android';
  return 'desktop';
}
